import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { PAGE_SUB_TYPE, PAGE_TYPE } from 'constants/footPrintTracking';
import useFootPrintTracker, { FootPrintTracking } from 'components/Globals/FootPrintTracking';
import { Router, withTranslation } from '../../src/i18n';
import route from '../../constants/routes';
import { getList } from '../../containers/App/actions';
import { PROFILES_ENDPOINT } from '../../constants/endpointConstants';
import ComposerPage from '../../containers/Composers';
import getInjectors from '../../store/reducerInjectors';
import reducer, { key } from '../../containers/Composers/reducer';
import { TP, PROFESSION_IDS } from '../../constants/consts';
import { getComposerListAction } from '../../containers/Composers/actions';
import { useInjectReducer } from '../../store/injectReducer';

const trackingData = {
  pageType: PAGE_TYPE.LISTING_PAGE,
  pageSubType: PAGE_SUB_TYPE.PROFILE,
};

const Composers = ({ t }) => {
  useInjectReducer([{ key, reducer }]);
  const dispatch = useDispatch();
  const trackFingerPrint = useFootPrintTracker();
  const onChangePage = pagination => {
    dispatch(
      getList({
        endpoint: PROFILES_ENDPOINT,
        sagaRoutine: getComposerListAction,
        params: { pagination, filter: { profession_id: PROFESSION_IDS.COMPOSER }, sort: '-production_count' },
      }),
    );
    trackFingerPrint(trackingData);
  };
  const submitFunc = query => {
    Router.push({
      pathname: `${route.COMPOSERS}/search`,
      query,
    });
  };

  const customBreadcrumbs = [
    { path: route.HOME, title: `${TP}.m_HOME` },
    { path: `${route.COMPOSERS}/`, title: `${TP}.m_COMPOSERS` },
  ];

  return (
    <FootPrintTracking data={trackingData}>
      <ComposerPage t={t} onChangePage={onChangePage} submitFunc={submitFunc} customBreadcrumbs={customBreadcrumbs} />
    </FootPrintTracking>
  );
};

Composers.getInitialProps = async ctx => {
  const { store } = ctx;
  getInjectors(store).injectReducer([{ key, reducer }]);

  store.dispatch(
    getList({
      endpoint: PROFILES_ENDPOINT,
      sagaRoutine: getComposerListAction,
      params: {
        pagination: { page: 1, limit: 10 },
        filter: { profession_id: PROFESSION_IDS.COMPOSER },
        sort: '-production_count',
      },
    }),
  );

  return {
    namespacesRequired: ['translation'],
  };
};

Composers.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('translation')(Composers);
